<template>

  <div class="layout" :class="{ 'is-workbench-layout': isWorkbench, 'is-camera-layout': isCameraMonitor }">

    <header class="topbar">

      <div class="topbar-inner">

        <div class="brand">

          <img class="logo-img" src="/portal/logo.png" alt="邯郸市研学旅行协会" />

          <div class="brand-text">

            <strong>邯郸市研学旅行协会</strong>

            <span>机构服务后台</span>

          </div>

        </div>



        <nav class="nav">

          <template v-for="item in menus">

            <div

              v-if="item.children && item.children.length"

              :key="'g-' + item.path"

              class="nav-group"

              :class="{ active: isGroupActive(item) }"

            >

              <span class="nav-item nav-parent" @click="goGroup(item)">

                {{ item.title }}

                <span v-if="menuBadge(item)" class="nav-badge">{{ menuBadge(item) }}</span>

                <i class="el-icon-arrow-down arrow" />

              </span>

              <div class="nav-drop">

                <router-link

                  v-for="child in item.children"

                  :key="child.path"

                  :to="child.path"

                  class="drop-item"

                  :class="{ active: activeMenu === child.path || $route.path === child.path }"

                >

                  {{ child.title }}

                </router-link>

              </div>

            </div>

            <router-link

              v-else

              :key="item.path"

              :to="item.path"

              class="nav-item"

              :class="{ active: activeMenu === item.path }"

            >

              {{ item.title }}

              <span v-if="menuBadge(item)" class="nav-badge">{{ menuBadge(item) }}</span>

            </router-link>

          </template>

        </nav>



        <div class="user-area">

          <div class="user-identity" :title="orgName">

            <span class="user-line">

              <em class="user-role">{{ orgTypeLabel }}</em>

              <i class="user-dot" />

              <span class="user-org">{{ orgName || '机构账号' }}</span>

            </span>

          </div>

          <button type="button" class="logout-link" @click="logout">退出登录</button>

        </div>

      </div>

    </header>



    <div v-if="activeChildren.length && !isCameraMonitor" class="ops-subnav">

      <div class="ops-subnav-inner">

        <router-link

          v-for="child in activeChildren"

          :key="child.path"

          :to="child.path"

          class="ops-sub-item"

          :class="{ active: $route.path === child.path }"

        >

          {{ child.title }}

        </router-link>

      </div>

    </div>



    <div v-if="showBreadcrumb && !isCameraMonitor" class="subnav">

      <div class="subnav-inner">

        <el-breadcrumb separator="/">

          <el-breadcrumb-item

            v-for="(item, index) in breadcrumbs"

            :key="index"

            :to="item.path || undefined"

          >

            {{ item.title }}

          </el-breadcrumb-item>

        </el-breadcrumb>

        <span class="route-path">{{ $route.path }}</span>

      </div>

    </div>



    <main class="main" :class="{ 'is-workbench': isWorkbench, 'is-camera': isCameraMonitor }">

      <router-view />

    </main>

  </div>

</template>



<script>

import { mapGetters } from 'vuex'

import request from '@/utils/request'



export default {

  name: 'Layout',

  data() {

    return {

      menuBadges: {}

    }

  },

  computed: {

    ...mapGetters(['menus', 'orgName', 'orgTypeLabel']),

    activeMenu() {

      const path = this.$route.path

      const meta = this.$route.meta || {}

      const from = this.$route.query.from

      if (from && typeof from === 'string') {

        const menuPaths = this.collectMenuPaths(this.menus || [])

        if (menuPaths.includes(from)) return from

      }

      if (Array.isArray(meta.menuPaths)) {

        const menuPaths = this.collectMenuPaths(this.menus || [])

        const hit = meta.menuPaths.find(p => menuPaths.includes(p))

        if (hit) return hit

      }

      if (meta.menuPath) {

        return meta.menuPath

      }

      const list = this.menus || []

      let matched = ''

      list.forEach(item => {

        if (item.children && item.children.length) {

          item.children.forEach(child => {

            if (path === child.path || path.startsWith(child.path + '/')) {

              if (child.path.length > matched.length) matched = child.path

            }

          })

          if (path === item.path || path.startsWith(item.path + '/')) {

            if (item.path.length > matched.length) matched = item.path

          }

        } else if (path === item.path || path.startsWith(item.path + '/')) {

          if (item.path.length > matched.length) matched = item.path

        }

      })

      return matched || path

    },

    activeChildren() {

      const list = this.menus || []

      const path = this.$route.path

      for (const item of list) {

        if (!item.children || !item.children.length) continue

        if (path === item.path || path.startsWith(item.path + '/')) return item.children

        const hit = item.children.some(c => path === c.path || path.startsWith(c.path + '/'))

        if (hit) return item.children

      }

      return []

    },

    profileMenuTitle() {

      const item = (this.menus || []).find(m => m.path === '/profile')

      return (item && item.title) || '机构资料'

    },

    breadcrumbs() {

      const meta = this.$route.meta || {}

      if (Array.isArray(meta.breadcrumb) && meta.breadcrumb.length) {

        return meta.breadcrumb.map((item, index) => {

          if (index === 0 && item.path === '/profile') {

            return { ...item, title: this.profileMenuTitle }

          }

          return item

        })

      }

      return []

    },

    showBreadcrumb() {

      return this.breadcrumbs.length > 1

    },

    isWorkbench() {

      return this.$route.path === '/dashboard' || this.$route.path === '/'

    },

    isCameraMonitor() {

      return this.$route.path === '/camera' || !!(this.$route.meta && this.$route.meta.darkLayout)

    }

  },

  created() {

    if (this.$store.getters.token) {

      this.$store.dispatch('user/getInfo').catch(() => {})

      this.loadMenuBadges()

    }

  },

  watch: {

    '$route.path'() {

      this.loadMenuBadges()

    }

  },

  methods: {

    async loadMenuBadges() {

      if (!this.$store.getters.token) return

      try {

        const res = await request({ url: '/storeapi/dashboard/menuBadges', method: 'get' })

        this.menuBadges = (res.data && typeof res.data === 'object') ? res.data : {}

      } catch (e) {

        this.menuBadges = {}

      }

    },

    menuBadge(item) {

      const key = item && item.badgeKey

      if (!key) return 0

      const n = Number(this.menuBadges[key] || 0)

      return n > 0 ? (n > 99 ? '99+' : n) : 0

    },

    collectMenuPaths(menus) {

      const paths = []

      ;(menus || []).forEach(item => {

        if (item.path) paths.push(item.path)

        ;(item.children || []).forEach(child => {

          if (child.path) paths.push(child.path)

        })

      })

      return paths

    },

    isGroupActive(item) {

      const path = this.$route.path

      if (path === item.path || path.startsWith(item.path + '/')) return true

      return (item.children || []).some(c => path === c.path || path.startsWith(c.path + '/'))

    },

    goGroup(item) {

      const first = item.children && item.children[0]

      if (first) this.$router.push(first.path).catch(() => {})

      else if (item.path) this.$router.push(item.path).catch(() => {})

    },

    async logout() {

      try {

        await this.$confirm('确认退出登录？', '提示', {

          type: 'warning',

          confirmButtonText: '退出',

          cancelButtonText: '取消'

        })

      } catch (e) {

        return

      }

      await this.$store.dispatch('user/logout')

      this.$router.push('/login')

    }

  }

}

</script>



<style lang="scss" scoped>

.layout {

  min-height: 100vh;

  display: flex;

  flex-direction: column;

  background: #f3f6f5;



  &.is-workbench-layout {

    height: 100vh;

    overflow: hidden;

    background: #e8f1f8;

  }



  &.is-camera-layout {

    height: 100vh;

    overflow: hidden;

    background: #060d18;



    .topbar {

      background: linear-gradient(180deg, #0c1829 0%, #081220 100%);

      border-bottom: 1px solid rgba(0, 180, 255, 0.12);

      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.45);

    }



    .brand-text strong { color: #e8f4ff; }

    .brand-text span { color: #4fc3f7; }

    .logo-img { border-color: rgba(79, 195, 247, 0.25); background: rgba(255, 255, 255, 0.06); }



    .nav-item {

      color: #8eb4d4;

      &:hover { color: #4fc3f7; }

      &.active {

        color: #4fc3f7;

        &::after { background: linear-gradient(90deg, #00b4ff, #4fc3f7); }

      }

    }



    .nav-group.active > .nav-parent {

      color: #4fc3f7;

      &::after { background: linear-gradient(90deg, #00b4ff, #4fc3f7); }

    }



    .nav-drop {

      background: #0f1f35;

      border-color: rgba(0, 180, 255, 0.15);

      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5);

    }



    .drop-item {

      color: #8eb4d4;

      &:hover, &.active {

        color: #4fc3f7;

        background: rgba(0, 180, 255, 0.08);

      }

    }



    .user-area {

      border-left-color: rgba(0, 180, 255, 0.15);

    }



    .user-area .user-identity {

      border-right-color: rgba(0, 180, 255, 0.15);

    }



    .user-area .user-role { color: #4fc3f7; }

    .user-area .user-dot { background: rgba(79, 195, 247, 0.45); }

    .user-area .user-org { color: #d4e8f8; }



    .nav-badge {

      background: #ff4d4f;

      color: #fff;

    }



    .user-area .logout-link {

      color: #7eb8dc;

      &:hover { color: #ff7875; }

    }

  }

}



.topbar {

  position: sticky;

  top: 0;

  z-index: 100;

  background: #fff;

  border-bottom: 1px solid #e6eeea;

  box-shadow: 0 1px 0 rgba(15, 138, 106, 0.04), 0 8px 24px rgba(15, 40, 30, 0.04);

}



.topbar-inner {

  height: 64px;

  padding: 0 20px;

  display: flex;

  align-items: center;

  gap: 24px;

}



.brand {

  display: flex;

  align-items: center;

  gap: 12px;

  flex-shrink: 0;

  min-width: 200px;



  .logo-img {

    width: 42px;

    height: 42px;

    border-radius: 50%;

    background: #fff;

    object-fit: contain;

    border: 1px solid #e8f0ec;

  }



  .brand-text {

    display: flex;

    flex-direction: column;

    line-height: 1.25;



    strong {

      font-size: 15px;

      font-weight: 700;

      color: #12352c;

      letter-spacing: 0.02em;

    }



    span {

      margin-top: 2px;

      font-size: 12px;

      color: #0f8a6a;

      font-weight: 500;

    }

  }

}



.nav {

  flex: 1;

  display: flex;

  align-items: stretch;

  height: 100%;

  gap: 4px;

  overflow-x: auto;

  min-width: 0;



  &::-webkit-scrollbar {

    display: none;

  }

}



.nav-item {

  position: relative;

  display: inline-flex;

  align-items: center;

  padding: 0 16px;

  font-size: 14px;

  font-weight: 500;

  color: #4a5f58;

  text-decoration: none;

  white-space: nowrap;

  transition: color 0.2s ease;



  &::after {

    content: '';

    position: absolute;

    left: 16px;

    right: 16px;

    bottom: 0;

    height: 3px;

    border-radius: 3px 3px 0 0;

    background: transparent;

    transition: background 0.2s ease;

  }



  &:hover {

    color: #0f8a6a;

  }



  &.active {

    color: #0a6b52;

    font-weight: 700;



    &::after {

      background: #0f8a6a;

    }

  }

}



.nav-group {

  position: relative;

  display: inline-flex;

  align-items: stretch;

  height: 100%;



  &.active > .nav-parent {

    color: #0a6b52;

    font-weight: 700;



    &::after {

      background: #0f8a6a;

    }

  }



  &:hover .nav-drop {

    display: block;

  }

}



.nav-parent {

  cursor: pointer;



  .arrow {

    margin-left: 4px;

    font-size: 12px;

  }

}



.nav-drop {

  display: none;

  position: absolute;

  top: calc(100% - 2px);

  left: 0;

  min-width: 140px;

  padding: 6px 0;

  background: #fff;

  border: 1px solid #e6eeea;

  border-radius: 6px;

  box-shadow: 0 8px 24px rgba(15, 40, 30, 0.1);

  z-index: 120;

}



.drop-item {

  display: block;

  padding: 8px 16px;

  font-size: 13px;

  color: #4a5f58;

  text-decoration: none;



  &:hover,

  &.active {

    color: #0f8a6a;

    background: #f2faf7;

  }

}



.ops-subnav {

  background: #fff;

  border-bottom: 1px solid #e6eeea;

}



.ops-subnav-inner {

  display: flex;

  align-items: center;

  gap: 4px;

  padding: 0 20px;

  height: 42px;

}



.ops-sub-item {

  display: inline-flex;

  align-items: center;

  height: 30px;

  padding: 0 14px;

  border-radius: 15px;

  font-size: 13px;

  color: #4a5f58;

  text-decoration: none;



  &:hover {

    color: #0f8a6a;

    background: #f2faf7;

  }



  &.active {

    color: #fff;

    background: #0f8a6a;

  }

}



.nav-badge {

  display: inline-flex;

  align-items: center;

  justify-content: center;

  min-width: 18px;

  height: 18px;

  padding: 0 5px;

  margin-left: 6px;

  border-radius: 999px;

  font-size: 11px;

  font-weight: 700;

  line-height: 1;

  background: #ff4d4f;

  color: #fff;

  vertical-align: middle;

}



.user-area {

  display: flex;

  align-items: center;

  flex-shrink: 0;

  margin-left: auto;

  padding-left: 18px;

  border-left: 1px solid #e8f0ec;



  .user-identity {

    display: flex;

    align-items: center;

    padding-right: 18px;

    margin-right: 18px;

    border-right: 1px solid #e8f0ec;

    min-width: 0;

  }



  .user-line {

    display: flex;

    align-items: center;

    gap: 8px;

    min-width: 0;

  }



  .user-role {

    flex-shrink: 0;

    font-style: normal;

    font-size: 12px;

    font-weight: 600;

    color: #0f8a6a;

    letter-spacing: 0.04em;

  }



  .user-dot {

    flex-shrink: 0;

    width: 3px;

    height: 3px;

    border-radius: 50%;

    background: #c5d5d0;

  }



  .user-org {

    font-size: 13px;

    color: #3d524c;

    max-width: 168px;

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap;

  }



  .logout-link {

    flex-shrink: 0;

    padding: 0;

    border: none;

    background: none;

    font-size: 13px;

    color: #8a9f98;

    cursor: pointer;

    transition: color 0.2s ease;

    white-space: nowrap;



    &:hover {

      color: #e05353;

    }

  }

}



.subnav {

  background: #fff;

  border-bottom: 1px solid #e6eeea;

}



.subnav-inner {

  height: 44px;

  padding: 0 20px;

  display: flex;

  align-items: center;

  justify-content: space-between;

  gap: 16px;

}



.route-path {

  font-size: 12px;

  color: #8aa099;

  font-family: Consolas, Monaco, monospace;

}



.main {

  flex: 1;

  padding: 20px;



  &.is-workbench {

    padding: 0;

    display: flex;

    flex-direction: column;

    min-height: 0;

    overflow: hidden;

  }



  &.is-camera {

    padding: 0;

    display: flex;

    flex-direction: column;

    min-height: 0;

    overflow: hidden;

    background: #060d18;

  }

}



@media (max-width: 960px) {

  .brand-text strong {

    display: none;

  }



  .brand {

    min-width: auto;

  }



  .user-area .user-org {

    max-width: 96px;

  }



  .user-area .user-dot {

    display: none;

  }



  .route-path {

    display: none;

  }

}

</style>

